import {app} from "../../config/constants";
import {api} from "../index";
import * as PromotionsActions from './actions'
import {store} from "../../reducers"
import axios from 'axios';
import { apiSettings } from "../../config/api";
import {ApiToken} from "../../config/api";
import PromotionVariantActieblockComponent from '../../application/components/promotions/components/types/variants/actieblock'
import PromotionVariantAcademyCardComponent from '../../application/components/promotions/components/types/variants/academyCard'
import PromotionVariantHomepageAdvertorialComponent from '../../application/components/promotions/components/types/variants/homepageAdvertorial'
import PromotionVariantHomepageAdvertorialComponentFw7 from '../../application/components/promotions/components/types/variants/homepageAdvertorialFw7'
import PromotionVariantStreamComponent from '../../application/components/promotions/components/types/variants/stream'
import PromotionVariantShoutComponent from '../../application/components/promotions/components/types/variants/shout'
import PromotionVariantSquareComponent from '../../application/components/promotions/components/types/variants/square'
import PromotionVariantSkyscraperComponent from '../../application/components/promotions/components/types/variants/skyscraper'
import PromotionVariantCatPartnerComponent from '../../application/components/promotions/components/types/variants/catPartner'
import PromotionVariantTopicPartnerComponent from '../../application/components/promotions/components/types/variants/topicPartner'
import PromotionVariantSideFeaturedPostComponent from '../../application/components/promotions/components/types/variants/sideFeaturedPost'
import PromotionVariantSideTextAdComponent from '../../application/components/promotions/components/types/variants/sideTextAd'
import PromotionVariantSidePlaceholderComponent from '../../application/components/promotions/components/types/variants/sideVariantPlaceholder'
import PromotionVariantSideRectangleComponent from '../../application/components/promotions/components/types/variants/sideRectangle'
import PromotionVariantSideSkyscraperComponent from '../../application/components/promotions/components/types/variants/sideSkyscraper'
import PromotionVariantSideLeadCollectorComponent from '../../application/components/promotions/components/types/variants/sideLeadCollector'
import PromotionVariantSideFreeProductComponent from '../../application/components/promotions/components/types/variants/sideFreeProduct'
import PromotionVariantAnchorCTAComponent from '../../application/components/promotions/components/types/variants/anchorCTA'
import PromotionVariantTopicAlertComponent from '../../application/components/promotions/components/types/variants/topicAlert'


import PromotionGeneralActieblockComponent from '../../application/components/promotions/components/types/general/actieblock'
import PromotionGeneralAcademyCardComponent from '../../application/components/promotions/components/types/general/academyCard'
import PromotionGeneralHomepageAdvertorialComponent from '../../application/components/promotions/components/types/general/homepageAdvertorial'
import PromotionGeneralHomepageAdvertorialComponentFw7 from '../../application/components/promotions/components/types/general/homepageAdvertorialFw7'
import PromotionGeneralStreamComponent from '../../application/components/promotions/components/types/general/stream'
import PromotionGeneralShoutComponent from '../../application/components/promotions/components/types/general/shout'
import PromotionGeneralBrandedPostComponent from '../../application/components/promotions/components/types/general/branded'
import PromotionGeneralSquareComponent from '../../application/components/promotions/components/types/general/square'
import PromotionGeneralCatPartnerComponent from '../../application/components/promotions/components/types/general/catPartner'
import PromotionGeneralTopicPartnerComponent from '../../application/components/promotions/components/types/general/topicPartner'
import PromotionGeneralTopicAlertComponent from '../../application/components/promotions/components/types/general/topicAlert'

import PromotionSideComponent from '../../application/components/promotions/components/types/general/side';

export const deletePromotion = async (promotion) => {
	return new Promise( ( resolve, reject ) => {
		// Get the promotion, then the Periods and Period variants of the promotion
		app.database().ref('/cams/promotions/promotions').child(promotion.key).once('value', async ( promotionSnap ) => {
			await deletePeriods(promotionSnap);
		});

		api.statistics.deleteStatistics(promotion.key).then( () => {
			app.database().ref('/cams/promotions/promotions/' + promotion.key).set(null).then( () => {
				resolve();
			});
		});
	})
};

const deletePeriods = async (promotionSnap) => {

	return new Promise( ( resolve, reject ) => {
		// get the periods
		app.database().ref('/cams/promotions/periods').orderByChild('promotionID').equalTo(promotionSnap.key).once( 'value', ( periodsSnap ) => {
			periodsSnap.forEach( async ( period ) => {
				await deletePeriod( period );
			});

			resolve();
		})
	})
};

const deletePeriod = async (period) => {
	return new Promise( ( resolve, reject ) => {
		api.statistics.deleteStatistics(period.key).then( async () => {
			await deletePeriodVariants(period.key);

			app.database().ref('/cams/promotions/periods/' + period.key ).set(null).then( () => {
				resolve();
			})
		});
	});
};

export const deleteSinglePeriod = async period => {
	return new Promise( ( resolve, reject ) => {
		deletePeriod( period ).then( () => {
			store.dispatch( PromotionsActions.deleteSinglePeriod(period) );

			resolve();
		})
	});
};

const deletePeriodVariants = async (periodId) => {
	return new Promise( ( resolve, reject ) => {
		if ( undefined === periodId ) {
			resolve();
			return null;
		}
		app.database().ref('/cams/promotions/variants').orderByChild('periodId').equalTo(periodId).once('value', async (variantsSnap) => {
			variantsSnap.forEach( async ( variant ) => {
				await deletePeriodVariant(variant);
			});

			resolve();
		})
	})
};

const deletePeriodVariant = async (variant) => {
	return new Promise( ( resolve, reject ) => {
		api.statistics.deleteStatistics(variant.key).then( () => {
			app.database().ref('/cams/promotions/variants/' + variant.key ).set(null).then( () => {
				resolve();
			});
		})
	});
};

export const create = async (data) => {
	let errors = [];

	const PromotionsRef = app.database().ref('/cams/promotions');

	const state = store.getState();

	let {promotion} = {...state};

	let promotionErrors = await checkPromotion(promotion);

	errors = errors.concat( promotionErrors );

	let promotionPeriodErrors = await checkPromotionPeriods();

	errors = errors.concat( promotionPeriodErrors );

	if ( errors.length === 0 ) {
		// First create a new promotion ID
		const newPromotionRef = PromotionsRef.child('promotions').push();
		const newPromotionId = newPromotionRef.key;

		// We now have the newPromotionRef, let's write the data to the database
		// console.log( newPromotionRef.key );

		return new Promise((createResolve, createReject) => {
			new Promise((periodResolve, reject) => {
				promotion.periods.map((period, periodKey) => {

					PromotionsRef.child('periods').push({
						promotionID: newPromotionId,
						startDateTimeStamp: period.startDateTimeStamp,
						endDateTimeStamp: period.endDateTimeStamp,
					}).then(periodSnap => {
						new Promise((resolve, reject) => {
							promotion.periods[periodKey].variants.map((variant, variantKey) => {

								variant = {...variant, periodId: periodSnap.key};
								PromotionsRef.child('variants').push(variant).then((variantSnap) => {
									if (variantKey === ( promotion.periods[periodKey].variants.length - 1 )) {
										resolve();
									}
								});
							});
						}).then(() => {
							if (periodKey === ( promotion.periods.length - 1 )) {
								periodResolve();
							}
						});
					})
				});
			}).then(() => {
				delete promotion.periods;

				let internalId = newPromotionRef.key;
				internalId.replace(/(\\|\/)/g, '');

				promotion = {
					...promotion,
					internalId: internalId
				};

				newPromotionRef.set(promotion).then(() => {
					resetPromotion();

					axios.post( `${apiSettings.baseUri}/cache/flush/${promotion.position}`, {}, {
						headers: {
							'x-access-token': ApiToken
						}
					} ).then( ( response ) => {
						createResolve(internalId);
					} ).catch( () => {
						createResolve(internalId);
					} );
				});
			})
		});
	} else {
		return Promise.reject( errors );
	}
};

const updatePromotionData = async (promotionKey, promotionData) => {
	return new Promise((resolve, reject) => {
		delete promotionData.campaignSnap;
		delete promotionData.department;
		delete promotionData.subject;
		delete promotionData.type;

		app.database().ref('/cams/promotions/promotions').child(promotionKey).set(promotionData).then(() => {
			resolve();
		});
	})
};

const upsertPromotionPeriods = async ( promotionKey, promotionPeriods ) => {
	return new Promise( ( resolve, reject ) => {
		for ( const promotionPeriod of promotionPeriods ) {
			const variants = promotionPeriod.variants;
			const periodKey = promotionPeriod.key;

			delete promotionPeriod.variants;
			delete promotionPeriod.key;

			// Check if this is a existing period
			if ( undefined === periodKey ) {
				// New period. Create...
				// app.database().ref('/cams/promotions/periods').push()
				promotionPeriod.promotionID = promotionKey;

				app.database().ref('/cams/promotions/periods').push( promotionPeriod ).then( ( periodSnap ) => {
					upsertPromotionPeriodVariants(periodSnap.key, variants).then(() => {
						resolve();
					})
				});
			} else {
				app.database().ref('/cams/promotions/periods').child(periodKey).set( promotionPeriod ).then( ( periodSnap ) => {
					upsertPromotionPeriodVariants(periodKey, variants).then(() => {
						resolve();
					})
				});
			}
		}
	})
};

const upsertPromotionPeriodVariants = async (periodKey, periodVariants) => {
	return new Promise( async ( resolve, reject ) => {
		let i = 0;

		for ( const variant of periodVariants ) {
			const variantKey = variant.key;

			delete variant.key;

			if ( undefined === variantKey ) {
				// Not existing, so create
				variant.periodId = periodKey;
				await app.database().ref('/cams/promotions/variants').push(variant);
			} else {
				await app.database().ref('/cams/promotions/variants').child(variantKey).set(variant);
			}

			if ( ++i === periodVariants.length ) {
				resolve();
			}
		}
	});
};

const checkPromotionPeriodVariant = async ( variant, periodNumber, promotionType, variantNumber ) => {
	let i = 0;
	let errors = [];
	const type = await types.find( ( type ) => {
		return type.value === promotionType;
	} );

	if ( undefined === type || 0 === type.requiredFields.variants.length ) {
		return Promise.resolve( errors );
	}

	for ( const requiredField of type.requiredFields.variants ) {

		if ( undefined === requiredField.type ) {
			requiredField.type = 'text';
		}

		if ( requiredField.type === 'text' && undefined === variant[ requiredField.key ] || '' === variant[ requiredField.key ] ) {
			errors.push( requiredField.error.replace('{period}', periodNumber ).replace( '{variant}', variantNumber ) );
		} else if ( requiredField.type === 'object' && ( undefined === variant[ requiredField.key ] || Object.keys(variant[ requiredField.key ]).length === 0 ) ) {
			errors.push( requiredField.error.replace('{period}', periodNumber ).replace( '{variant}', variantNumber ) );
		} else if ( requiredField.type === 'array' && ( undefined === variant[ requiredField.key ] || variant[ requiredField.key ].length === 0 ) ) {
			errors.push( requiredField.error.replace('{period}', periodNumber ).replace( '{variant}', variantNumber ) );
		}

		if ( ++i === type.requiredFields.variants.length ) {
			return Promise.resolve( errors );
		}
	}
};

const checkPromotionPeriods = async () => {
	let i = 0;
	let j = 0;
	let errors = [];
	const promotion = store.getState().promotion;

	const type = await types.find( ( type ) => {
		return type.value === promotion.position;
	} );

	if ( undefined === type || undefined !== type.hasPeriods && false === type.hasPeriods ) {
		return Promise.resolve( errors );
	}

	for ( const period of promotion.periods ) {
		// Check the variants
		const periodNumber = i + 1;

		if ( undefined === promotion.position || '' === promotion.position ) {
			return Promise.resolve( errors );
		}

		if ( '' === period.startDateTimeStamp === '' || undefined === period.startDateTimeStamp || 0 === period.startDateTimeStamp ) {
			errors.push( 'Je bent vergeten om een startdatum voor periode ' + periodNumber + ' in te voeren.');
		}

		if ( ( '' !== period.startDateTimeStamp && undefined !== period.startDateTimeStamp && 0 !== period.startDateTimeStamp ) && 0 !== period.endDateTimeStamp && undefined !== period.endDateTimeStamp && period.startDateTimeStamp >= period.endDateTimeStamp ) {
			errors.push( 'De einddatum van periode ' + periodNumber + ' is eerder of gelijk aan de startdatum. Hierdoor zal de promotie niet online komen.');
		}

		for ( const variant of period.variants ) {
			const variantErrors = await checkPromotionPeriodVariant( variant, periodNumber, promotion.position, ++j );

			errors = errors.concat( variantErrors );
		}

		if ( ++i === promotion.periods.length ) {
			return Promise.resolve( errors );
		}
	}
};

const checkPromotion = async ( promotion ) => {
	let i = 0;
	let errors = [];
	const type = await types.find( ( type ) => {
		return type.value === promotion.position;
	} );

	if ( '' === promotion.position || undefined === promotion.position ) {
		errors.push( 'Laten we om te beginnen eerst een positie selecteren' );
	}

	if ( undefined === type || 0 === type.requiredFields.promotion.length ) {
		return Promise.resolve( errors );
	}

	for ( const requiredField of type.requiredFields.promotion ) {
		if ( undefined === promotion[ requiredField.key ] || '' === promotion[ requiredField.key ] ) {
			errors.push( requiredField.error );
		}

		if ( ++i === type.requiredFields.promotion.length ) {
			return Promise.resolve( errors );
		}
	}

};

export const update = async () => {
	let errors = [];
	const state = store.getState();

	let promotionData = state.promotion;
	let promotionErrors = await checkPromotion(promotionData);

	errors = errors.concat( promotionErrors );

	let promotionPeriodErrors = await checkPromotionPeriods();

	errors = errors.concat( promotionPeriodErrors );

	if ( errors.length === 0 ) {

		const promotionPeriods = promotionData.periods;
		const promotionKey = promotionData.key;

		delete promotionData.periods;
		delete promotionData.key;

		await updatePromotionData(promotionKey, promotionData);
		await upsertPromotionPeriods(promotionKey, promotionPeriods);

		axios.post( `${apiSettings.baseUri}/cache/flush/${promotionData.position}`, {}, {
			headers: {
				'x-access-token': ApiToken
			}
		} );

		return Promise.resolve(promotionData.internalId);
	} else {
		return Promise.reject( errors );
	}
};

export const resetPromotion = () => {
	store.dispatch(PromotionsActions.resetPromotion());
};

export const getPromotionData = async (internalId) => {
	// Get the promotion
	let promotion = {};

	return new Promise((resolve, reject) => {
		app.database().ref('/cams/promotions/promotions').orderByChild('internalId').equalTo(internalId).once('value', (promotionsSnap) => {
			promotionsSnap.forEach(async (promo) => {
				promotion = promo.val();
				promotion.key = promo.key;

				resolve(promotion);
			});
		});
	})
};

export const getPromotionPeriods = async (promotion) => {
	let periods = [];

	return new Promise((resolve, reject) => {
		let i = 0;

		app.database().ref('/cams/promotions/periods').orderByChild('promotionID').equalTo(promotion.key).once('value', (periodsSnap) => {
			periodsSnap.forEach( (period) => {
				let periodData = period.val();
				periodData.key = period.key;

				// periodData.variants = await getPeriodVariants(periodData);
				//
				// periods.push(periodData);

				// if (periods.length === periodsSnap.numChildren()) {
				// 	resolve(periods);
				// }
				//

				getPeriodVariants(periodData).then( ( variants ) => {
					periodData.variants = variants;

					periods.push(periodData);


					if (++i === periodsSnap.numChildren()) {
						resolve(periods);
					}
				});
			});
		});
	})
};

export const getPeriodVariants = async (period) => {
	let variants = [];

	return new Promise((resolve, reject) => {
		let i = 0;

		app.database().ref('/cams/promotions/variants').orderByChild('periodId').equalTo(period.key).once('value', (variantsSnap) => {
			if (null === variantsSnap.val()) {
				resolve(variants);
			}

			variantsSnap.forEach((variant) => {
				variants[i] = variant.val();
				variants[i].key = variant.key;

				if (++i === variantsSnap.numChildren()) {
					resolve(variants);
				}
			});
		});
	});
};

export const getPromotion = async (internalId) => {
	return new Promise(async (resolve, reject) => {
		let promotion = await getPromotionData(internalId);

		promotion.periods = await getPromotionPeriods(promotion);
		promotion.campaignSnap = await api.campaigns.getCampaign(promotion.campaign);
		promotion.isActive = await isActive(promotion.periods);
		promotion.type = await getCampaignType(promotion.campaignSnap);
		promotion.subject = await getCampaignSubject(promotion.campaignSnap);
		promotion.department = await getCampaignDepartment(promotion.campaignSnap);
		promotion.views = await getPromotionStats(promotion, 'views');
		promotion.clicks = await getPromotionStats(promotion, 'clicks');

		resolve(promotion);
	});
};

export const getPromotionStats = async (promotion, type ) => {
	let views = 0;
	let i = 0;

	return new Promise( ( resolve, reject ) => {
		promotion.periods.forEach( async ( period ) => {
			return new Promise( ( resolve, reject ) => {
				let j = 0;

				if ( period.variants.length > 0 ) {
					period.variants.forEach( async ( variant ) => {
						views += await getStats(variant.key, type);
	
						if ( ++j === period.variants.length ) {
							resolve(views);
						}
					});	
				} else {
					resolve( 0 );
				}
			}).then( ( views ) => {
				if ( ++i === promotion.periods.length ) {
					resolve(views);
				}
			});
		});
	});
};

export const getStats = (key, table) => {
	return new Promise( ( resolve, reject ) => {
		app.database().ref('/cams/statistics/simple/' + table ).child(key).once('value', ( statisticsSnap ) => {
			if ( null !== statisticsSnap.val() ) {
				resolve( statisticsSnap.val()[table] );
			} else {
				resolve( 0 );
			}
		});
	});
};


export const getCampaignType = (campaign) => {
	return new Promise( ( resolve, reject ) => {
		app.database().ref('/cams/settings/campaigns/types/' + campaign.val().type ).once( 'value', ( typeSnap ) => {
			resolve( typeSnap );
		})
	});
};

export const getCampaignSubject = (campaign) => {
	return new Promise( ( resolve, reject ) => {
		app.database().ref('/cams/settings/campaigns/subjects/' + campaign.val().subject ).once( 'value', ( subjectSnap ) => {
			resolve( subjectSnap );
		})
	});
};

export const getCampaignDepartment = (campaign) => {
	return new Promise( ( resolve, reject ) => {
		app.database().ref('/cams/settings/campaigns/departments/' + campaign.val().department ).once( 'value', ( departmentSnap ) => {
			resolve( departmentSnap );
		})
	});
};

export const isActive = (promotionPeriods) => {
	return new Promise( ( resolve, reject ) => {
		const currentTime = Date.now();
		let i = 0;

		promotionPeriods.map( (period ) => {
			if ( currentTime >= period.startDateTimeStamp && currentTime <= period.endDateTimeStamp ) {
				resolve(true);
			}

			if ( ++i === promotionPeriods.length ) {
				resolve(false);
			}
		})
	});
};

const cleanVariantKeys = period => {
	return new Promise( ( resolve, reject ) => {
		let i = 0;
		period.variants.map( variant => {
			delete variant.key;
			delete variant.periodId;
			variant.active = false;

			if ( ++i === period.variants.length ) {
				resolve( period );
			}
		});
	})
};

const cleanPeriods = async ( promotion ) => {
	return new Promise( ( resolve, reject ) => {
		let i = 0;
		promotion.periods.map( async period => {
			period = await cleanVariantKeys(period);
			delete period.key;
			delete period.promotionID;

			if ( ++i === promotion.periods.length ) {
				resolve( promotion );
			}
		});
	});
};

export const cleanPromotion = (promotion) => {
	return new Promise( async ( resolve, reject ) => {
		delete promotion.key;
		delete promotion.internalId;
		delete promotion.campaignSnap;
		delete promotion.department;
		delete promotion.subject;
		delete promotion.type;

		promotion = await cleanPeriods( promotion );

		resolve( promotion );
	});
};

export const setNewPromotion = promotion => {
	return new Promise( ( resolve, reject ) => {
		store.dispatch(PromotionsActions.setPromotion(promotion));

		resolve();
	})
};

export const setPromotion = (internalPromotionId) => {
	getPromotion(internalPromotionId).then((promotion) => {
		store.dispatch(PromotionsActions.setPromotion(promotion));
	});
};

export const handlePositionFieldState = (name, value, periodKey, variantKey) => {
	store.dispatch(PromotionsActions.handlePositionFieldState(name, value, periodKey, variantKey));
};

export const handlePeriodFieldState = ( name, value, periodKey ) => {
	store.dispatch( PromotionsActions.handlePeriodFieldState( name, value, periodKey ) );
};

export const handleState = (name, value) => {
	store.dispatch(PromotionsActions.handleState(name, value));
};

export const addPeriod = (event, period = false) => {
	store.dispatch(PromotionsActions.addPeriod(period));

	event.preventDefault();
};

export const removeVariation = (periodKey, variantKey) => {
	store.dispatch( PromotionsActions.removeVariation(periodKey, variantKey ) );

	return Promise.resolve();
};

export const addPeriodVariantAction = (periodKey, variant = false) => {
	store.dispatch(PromotionsActions.addPeriodVariant(periodKey, variant));
};

export const types = [
	{
		components: {
			general: PromotionGeneralActieblockComponent,
			variant: PromotionVariantActieblockComponent,
			side: false,
		},
		title: 'Actieblok',
		value: 'actieblock',
		hasUrl: true,
		images: {
			width: 214,
			height: 156,
		},
		requiredFields: {
			variants: [
				{
					key: 'title',
					error: 'Het veld titel in periode {period}, variant {variant} is leeg.'
				},
				{
					key: 'text',
					error: 'Het veld promotietekst in periode {period}, variant {variant} is leeg.'
				},
				{
					key: 'ctatext',
					error: 'Het veld CTA Tekst in periode {period}, variant {variant} is leeg.'
				},
				{
					key: 'image',
					error: 'Het veld afbeelding in periode {period}, variant {variant} is leeg.',
					type: 'object',
				},
			],
			promotion: [
				{
					key: 'name',
					error: 'Je hebt geen titel ingevuld voor deze promotie',
				},
				{
					key: 'campaign',
					error: 'Je hebt geen campagne geselecteerd voor deze promotie',
				},
				{
					key: 'url',
					error: 'Je hebt geen URL ingevuld voor deze promotie',
				},
			]
		}
	},
	{
		components: {
			general: PromotionGeneralHomepageAdvertorialComponent,
			variant: PromotionVariantHomepageAdvertorialComponent,
			side: false,
		},
		title: 'Homepage advertorial',
		value: 'homepage_advertorial',
		hasUrl: true,
		images: {
			width: 345,
			height: 245,
		},
		requiredFields: {
			variants: [
				{
					key: 'label',
					error: 'Het veld label in periode {period}, variant {variant} is leeg.'
				},
				{
					key: 'title',
					error: 'Het veld titel in periode {period}, variant {variant} is leeg.'
				},
				{
					key: 'text',
					error: 'Het veld text in periode {period}, variant {variant} is leeg.'
				},
				{
					key: 'ctaText',
					error: 'Het veld CTA Tekst in periode {period}, variant {variant} is leeg.'
				},
				{
					key: 'image',
					error: 'Het veld afbeelding in periode {period}, variant {variant} is leeg.',
					type: 'object',
				},
			],
			promotion: [
				{
					key: 'name',
					error: 'Je hebt geen titel ingevuld voor deze promotie',
				},
				{
					key: 'campaign',
					error: 'Je hebt geen campagne geselecteerd voor deze promotie',
				},
				{
					key: 'url',
					error: 'Je hebt geen URL ingevuld voor deze promotie',
				},
			]
		}
	},
	{
		components: {
			general: PromotionGeneralHomepageAdvertorialComponentFw7,
			variant: PromotionVariantHomepageAdvertorialComponentFw7,
			side: false,
		},
		title: 'Advertorial FW7',
		value: 'homepage_advertorialFw7',
		hasUrl: true,
		images: {
			width: 345,
			height: 245,
		},
		requiredFields: {
			variants: [
				{
					key: 'label',
					error: 'Het veld label in periode {period}, variant {variant} is leeg.'
				},
				{
					key: 'title',
					error: 'Het veld titel in periode {period}, variant {variant} is leeg.'
				},
				{
					key: 'text',
					error: 'Het veld text in periode {period}, variant {variant} is leeg.'
				},
				{
					key: 'ctaText',
					error: 'Het veld CTA Tekst in periode {period}, variant {variant} is leeg.'
				},
				{
					key: 'image',
					error: 'Het veld afbeelding in periode {period}, variant {variant} is leeg.',
					type: 'object',
				},
			],
			promotion: [
				{
					key: 'name',
					error: 'Je hebt geen titel ingevuld voor deze promotie',
				},
				{
					key: 'campaign',
					error: 'Je hebt geen campagne geselecteerd voor deze promotie',
				},
				{
					key: 'url',
					error: 'Je hebt geen URL ingevuld voor deze promotie',
				},
			]
		}
	},
	{
		components: {
			general: PromotionGeneralStreamComponent,
			variant: PromotionVariantStreamComponent,
			side: false,
		},
		title: 'Topicad',
		value: 'stream',
		hasUrl: true,
		images: {
			width: 214,
			height: 156,
		},
		requiredFields: {
			variants: [
				{
					key: 'text',
					error: 'Het veld titel in periode {period}, variant {variant} is leeg.'
				},
				{
					key: 'image',
					error: 'Het veld afbeelding in periode {period}, variant {variant} is leeg.',
					type: 'object',
				},
			],
			promotion: [
				{
					key: 'name',
					error: 'Je hebt geen titel ingevuld voor deze promotie',
				},
				{
					key: 'campaign',
					error: 'Je hebt geen campagne geselecteerd voor deze promotie',
				},
				{
					key: 'url',
					error: 'Je hebt geen URL ingevuld voor deze promotie',
				},
			]
		}
	},
	{
		components: {
			general: PromotionGeneralShoutComponent,
			variant: PromotionVariantShoutComponent,
			side: false,
		},
		title: 'Campagnebalk',
		value: 'shout',
		hasUrl: true,
		images: false,
		requiredFields: {
			variants: [
				{
					key: 'text',
					error: 'Het veld tekst in periode {period}, variant {variant} is leeg.'
				},
			],
			promotion: [
				{
					key: 'name',
					error: 'Je hebt geen titel ingevuld voor deze promotie',
				},
				{
					key: 'campaign',
					error: 'Je hebt geen campagne geselecteerd voor deze promotie',
				},
				{
					key: 'url',
					error: 'Je hebt geen URL ingevuld voor deze promotie',
				},
			]
		}
	},
	{
		components: {
			general: PromotionGeneralBrandedPostComponent,
			variant: false,
			side: false,
		},
		title: 'Branded/promoted post',
		value: 'branded',
		hasUrl: false,
		images: false,
		hasPeriods: false,
		requiredFields: {
			variants: [],
			promotion: [
				{
					key: 'name',
					error: 'Je hebt geen titel ingevuld voor deze promotie',
				},
				{
					key: 'campaign',
					error: 'Je hebt geen campagne geselecteerd voor deze promotie',
				},
				{
					key: 'label',
					error: 'Je hebt geen label ingevuld voor deze promotie',
				},
				{
					key: 'postIds',
					error: 'Je moet minimaal 1 artikel selecteren.',
					type: 'array',
				},
				{
					key: 'startDateTimeStamp',
					error: 'Je bent vergeten om een startdatum te selecteren.'
				},
			],
		},
	},
	{
		components: {
			general: PromotionGeneralSquareComponent,
			variant: PromotionVariantSquareComponent,
			side: false,
		},
		title: 'Rectangle',
		value: 'square',
		hasUrl: true,
		images: {
			width: 336,
			height: 280,
		},
		requiredFields: {
			variants: [
				{
					key: 'image',
					error: 'Het veld afbeelding in periode {period}, variant {variant} is leeg.',
					type: 'object',
				},
			],
			promotion: [
				{
					key: 'name',
					error: 'Je hebt geen titel ingevuld voor deze promotie',
				},
				{
					key: 'campaign',
					error: 'Je hebt geen campagne geselecteerd voor deze promotie',
				},
				{
					key: 'url',
					error: 'Je hebt geen URL ingevuld voor deze promotie',
				},
			]
		}
	},
	{
		components: {
			general: PromotionGeneralSquareComponent,
			variant: PromotionVariantSkyscraperComponent,
			side: false,
		},
		title: 'Skyscraper',
		value: 'skyscraper',
		hasUrl: true,
		images: {
			width: 160,
			height: 600,
		},
		requiredFields: {
			variants: [
				{
					key: 'image',
					error: 'Het veld afbeelding in periode {period}, variant {variant} is leeg.',
					type: 'object',
				},
			],
			promotion: [
				{
					key: 'name',
					error: 'Je hebt geen titel ingevuld voor deze promotie',
				},
				{
					key: 'campaign',
					error: 'Je hebt geen campagne geselecteerd voor deze promotie',
				},
				{
					key: 'url',
					error: 'Je hebt geen URL ingevuld voor deze promotie',
				},
			]
		}
	},
	{
		components: {
			general: false,
			variant: PromotionVariantAnchorCTAComponent,
			side: PromotionSideComponent,
		},
		title: 'Anchor CTA',
		value: 'side_anchorcta',
		hasUrl: true,
		images: {
			width: 336,
			height: 280,
		},
		requiredFields: {
			variants: [
				{
					key: 'prefix',
					error: 'Je hebt geen prefix voor de CTA ingevuld.',
				}
			],
			promotion: [
				{
					key: 'name',
					error: 'Je hebt geen titel ingevuld voor deze promotie',
				},
				{
					key: 'campaign',
					error: 'Je hebt geen campagne geselecteerd voor deze promotie',
				},
				{
					key: 'url',
					error: 'Je hebt geen URL ingevuld voor deze promotie',
				},
			]
		}
	},
	{
		components: {
			general: false,
			variant: PromotionVariantSidePlaceholderComponent,
			side: false
		},
		title: 'Anchor CTA - Redactioneel',
		value: 'side_editorial_anchorcta',
		hasUrl: false,
		hasPeriods: true,
		images: {},
		requiredFields: {
			variants: [],
			promotion: []
		}
	},
	{
		components: {
			general: PromotionGeneralCatPartnerComponent,
			variant: false,
			side: false,
		},
		title: 'Categorie partner',
		value: 'cat_partner',
		hasUrl: true,
		images: {
			width: 190,
			height: 130,
		}
	},
	{
		components: {
			general: PromotionGeneralTopicPartnerComponent,
			variant: false,
			side: false,
		},
		title: 'Topic partner',
		value: 'topic_partner',
		hasUrl: true,
		images: {
			width: 190,
			height: 130,
		}
	},
	// {
	// 	components: {
	// 		general: false,
	// 		variant: PromotionVariantSideFeaturedPostComponent,
	// 		side: PromotionSideComponent
	// 	},
	// 	title: 'Kantlijn - Aanbevolen artikel',
	// 	value: 'side_featured_post',
	// 	hasUrl: false,
	// 	images: {
	// 		width: 190,
	// 		height: 130,
	// 	},
	// 	requiredFields: {
	// 		variants: [],
	// 		promotion: []
	// 	}
	// },
	// {
	// 	components: {
	// 		general: false,
	// 		variant: PromotionVariantSideTextAdComponent,
	// 		side: PromotionSideComponent
	// 	},
	// 	title: 'Kantlijn - Textad',
	// 	value: 'side_textad',
	// 	hasUrl: true,
	// 	images: {
	// 		width: 190,
	// 		height: 130,
	// 	},
	// 	requiredFields: {
	// 		variants: [],
	// 		promotion: []
	// 	}
	// },
	{
		components: {
			general: false,
			variant: PromotionVariantSidePlaceholderComponent,
			side: false
		},
		title: 'Kantlijn - Recente artikelen',
		value: 'side_recent_articles',
		hasUrl: false,
		hasPeriods: true,
		images: {},
		requiredFields: {
			variants: [],
			promotion: []
		}
	},
	// {
	// 	components: {
	// 		general: false,
	// 		variant: PromotionVariantSidePlaceholderComponent,
	// 		side: false
	// 	},
	// 	title: 'Kantlijn - Tag artikelen',
	// 	value: 'side_term_posts',
	// 	hasUrl: false,
	// 	hasPeriods: true,
	// 	images: {},
	// 	requiredFields: {
	// 		variants: [],
	// 		promotion: []
	// 	}
	// },
	// {
	// 	components: {
	// 		general: false,
	// 		variant: PromotionVariantSidePlaceholderComponent,
	// 		side: false
	// 	},
	// 	title: 'Kantlijn - Jobs',
	// 	value: 'side_job_posts',
	// 	hasUrl: false,
	// 	hasPeriods: true,
	// 	images: {},
	// 	requiredFields: {
	// 		variants: [],
	// 		promotion: []
	// 	}
	// },
	// {
	// 	components: {
	// 		general: false,
	// 		variant: PromotionVariantSidePlaceholderComponent,
	// 		side: false
	// 	},
	// 	title: 'Kantlijn - Whitepapers',
	// 	value: 'side_whitepapers',
	// 	hasUrl: false,
	// 	hasPeriods: true,
	// 	images: {},
	// 	requiredFields: {
	// 		variants: [],
	// 		promotion: []
	// 	}
	// },
	// {
	// 	components: {
	// 		general: false,
	// 		variant: PromotionVariantSideRectangleComponent,
	// 		side: PromotionSideComponent
	// 	},
	// 	title: 'Kantlijn - Rectangle',
	// 	value: 'side_rectangle',
	// 	hasUrl: true,
	// 	hasPeriods: true,
	// 	images: {},
	// 	requiredFields: {
	// 		variants: [],
	// 		promotion: []
	// 	}
	// },
	// {
	// 	components: {
	// 		general: false,
	// 		variant: PromotionVariantSideLeadCollectorComponent,
	// 		side: PromotionSideComponent
	// 	},
	// 	title: 'Kantlijn - Lead Collector',
	// 	value: 'side_lead_collector',
	// 	hasUrl: false,
	// 	hasPeriods: true,
	// 	images: {},
	// 	requiredFields: {
	// 		variants: [],
	// 		promotion: []
	// 	}
	// },
	// {
	// 	components: {
	// 		general: false,
	// 		variant: PromotionVariantSideFreeProductComponent,
	// 		side: PromotionSideComponent
	// 	},
	// 	title: 'Kantlijn - Gratis product',
	// 	value: 'side_free_product',
	// 	hasUrl: false,
	// 	hasPeriods: true,
	// 	images: {},
	// 	requiredFields: {
	// 		variants: [],
	// 		promotion: []
	// 	}
	// },
	{
		components: {
			general: PromotionGeneralTopicAlertComponent,
			variant: PromotionVariantTopicAlertComponent,
			side: false,
		},
		title: 'Promotie - Topic Alert',
		value: 'topicAlert',
		hasUrl: true,
		images: {
			width: 214,
			height: 156,
		},
		requiredFields: {
			variants: [],
			promotion: []
		}
	},
	{
		components: {
			general: PromotionGeneralAcademyCardComponent,
			variant: PromotionVariantAcademyCardComponent,
			side: false,
		},
		title: 'Academy Card',
		value: 'academyCard',
		hasUrl: true,
		images: {
			width: 767,
			height: 431,
		},
		requiredFields: {
			variants: [],
			promotion: []
		}
	},
];

export const defaultPromotion = {
	name: '',
	campaign: '',
	url: 'https://',
	position: 0,
	periods: [
		{
			startDateTimeStamp: Date.now(),
			endDateTimeStamp: Date.now(),
			variants: [
				{
					title: '',
					text: '',
					image: '',
				},
			]
		},
	]
};




// WEBPACK FOOTER //
// ./src/api/promotions/index.js